module.exports = __webpack_public_path__ + "static/ma-2-70f94347105b24dd1aab6cc160ce675d.png";